/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Action } from './action';


export interface ClientInfo {
    age?: number;
    cameraImage?: string;
    comparedAction?: Action;
    creationEpoch?: number;
    currentClub?: string;
    email?: string;
    favSport?: string;
    generatedBanner?: string;
    height?: number;
    highScore?: number;
    id?: string;
    liked?: boolean;
    name: string;
    nationality?: string;
    password?: string;
    phoneNumber?: string;
    poseData?: string;
    positionInCurrentClub?: string;
    uploadedMedia?: { [key: string]: string; };
    username?: string;
    weight?: number;
}

